import { defineEvent } from '../types/event';
export var QUICKADD_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_QuickAdd_button'
        }
    ]
});
